(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Findway-tw-table"] && !Shopify.designMode) return;
  try {
    
function cleanValue(v) {
  return v === undefined || v === null || v === 'undefined' ? '' : v;
}

function cleanNote(note) {
  note = cleanValue(note);
  if (!note) return '';

  try {
    if (note.charAt(0) === '[' && note.slice(-1) === ']') {
      var arr = JSON.parse(note);
      if (Array.isArray(arr)) return arr.join(', ');
    }
  } catch (e) {}
  return note;
}

function cleanYear(yr) {
  yr = cleanValue(yr);
  if (!yr) return '';

  try {
    if (yr.charAt(0) === '[' && yr.slice(-1) === ']') {
      var nums = JSON.parse(yr).map(function (n) { return parseInt(n, 10); })
                               .filter(function (n) { return !isNaN(n); });
      if (!nums.length) return '';
      var min = Math.min.apply(null, nums);
      var max = Math.max.apply(null, nums);
      return min === max ? String(min) : (min + '-' + max);
    }
  } catch (e) {}
  return yr;
}

function getLocalizedValue(row, field) {
  if (shopifyLocale === 'fr' && row.language?.fr?.[field]) {
    return row.language.fr[field];
  }
  return row[field];
}

document.addEventListener('DOMContentLoaded', function () {
  $(".fww-loading").removeClass("hidden");
  getPdpData().then(function (res) {
    if (!res || !res.pdpTable) return;

    var rows = res.pdpTable.filter(function (r) {
      return r && typeof r === 'object';
    });

    new DataTable('#fw-pdpTable', {
      pageLength: 25, 
      data: rows,
      layout: {
        bottom2Start: 'buttons'
      },
      buttons: [
        { extend: 'pdf',
          text: shopifyLocale === 'fr' ? 'Télécharger le PDF' : 'Download PDF',
          filename: (function () {
            const d = new Date();
            const yyyy = d.getFullYear();
            const mm   = String(d.getMonth() + 1).padStart(2, '0');
            const dd   = String(d.getDate()).padStart(2, '0');
            return 'PDP_List_' + `${yyyy}${mm}${dd}`;
          })(),
          title: shopifyLocale === 'fr'
            ? 'Liste du programme de développement de produits Findway'
            : 'Findway Product Development Program List',
          messageTop: shopifyLocale === 'fr'
            ? 'Les modèles peuvent être modifiés sans préavis. Veuillez nous contacter à l’avance lorsque vous aurez le véhicule qui nous intéresse. Les participants seront sélectionnés selon le principe du premier arrivé, premier servi.'
            : 'Models are subject to change without notice. Please contact us in advance once you have the vehicle we are interested in. Participants will be selected on a first-come, first-served basis.'
        }
      ],
      language: {
        lengthMenu: shopifyLocale === 'fr' ? '_MENU_ Modèles par page' : '_MENU_ Models Per Page',
        info: shopifyLocale === 'fr' ? 'Affichage de _START_ à _END_ sur _TOTAL_ modèles' : 'Showing _START_ to _END_ of _TOTAL_ Models',
      },
      fixedHeader: {
        header: true,
        headerOffset: 80
      },
      order: [[2, 'asc'], [3, 'asc'], [4, 'asc'], [5, 'asc']],
      columns: [
        {
          title: 'PDP #',
          data: null,
          render: function (_d, _t, row) {
            var v = '';
            if (row.Variants && row.Variants.length) {
              v = row.Variants[0].VariantSKU;
            }
            return cleanValue(v);
          }
        },
        {
          title: shopifyLocale === 'fr' ? 'Produit' : 'Product',
          data: null,
          render: function (_d, _t, row) {
            const v = getLocalizedValue(row, 'CollectionName');
            return cleanNote(v);
          }
        },
        {
          title: shopifyLocale === 'fr' ? 'Marque' : 'Make',
          data: 'Make',
          render: function (d) { return cleanValue(d); }
        },
        {
          title: shopifyLocale === 'fr' ? 'Modèle' : 'Model',
          data: null,
          render: function (_d, _t, row) {
            const v = getLocalizedValue(row, 'Model');
            return cleanNote(v);
          }
        },
        {
          title: shopifyLocale === 'fr' ? 'Année' : 'Year',
          data: 'Year',
          render: function (d) { return cleanYear(d); }
        },
        {
          title: shopifyLocale === 'fr' ? 'Option' : 'Option',
          data: null,
          render: function (_d, _t, row) {
            const v = getLocalizedValue(row, 'Option');
            return cleanNote(v);
          }
        },
        {
          title: shopifyLocale === 'fr' ? 'Remarque' : 'Note',
          data: null,
          render: function (_d, _t, row) {
            const v = getLocalizedValue(row, 'FitNote');
            return cleanNote(v);
          }
        }
      ]
    });
  }).finally(function () {
      $('.fww-loading').addClass('hidden');
  });
});

async function getPdpData() {
  try {
    const response = await fetch('https://yvycs6obckonwmguydydwvgu5e0njtzk.lambda-url.ca-central-1.on.aws/', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ pdpTable: true, lang: shopifyLocale }),
    });
 
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error(`Error fetching data for Colls:`, error);
    return null;
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Findway-tw-wholesale"] && !Shopify.designMode) return;
  try {
    
const header  = document.querySelector('#fww-selection-header');
const wrapper = document.querySelector('.fww-ssr-table');

header.style.transform = `translateX(-${wrapper.scrollLeft}px)`;

wrapper.addEventListener('scroll', () => {
  header.style.transform = `translateX(-${wrapper.scrollLeft}px)`;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Findway-twfb-partner-application"] && !Shopify.designMode) return;
  try {
    
document.getElementById('pa-form').addEventListener('submit', async (e) => {
  e.preventDefault();
  const form = e.target;
  var paformsubmitBtn = document.getElementById("paformsubmit");

  paformsubmitBtn.textContent = shopifyLocale === 'fr' ? 'Chargement...' : 'Loading...';
  const payload = {
    companyName:   form['company-name'].value.trim(),
    companyWeb:    form['company-web'].value.trim(),
    email:         form['email'].value.trim(),
    confirmEmail:  form['confirm-email'].value.trim(),
    phoneNumber:   form['pa-phone-Number'].value.trim(),
    typeofCompany: form['pa-typeof-Company'].value,
    typeofBusiness:form['pa-typeof-Business'].value.trim(),
    yearFounded:   form['pa-year-Funded'].value.trim(),
    employees:     form['number-of-employees'].value,
    targetMarket:  form['target-Market'].value.trim(),
    hearUs:        form['pa-hear-Us'].value.trim(),
    desc:          form['business-desc'].value.trim(),
    firstName:     form['pa-first-Name'].value.trim(),
    lastName:      form['pa-last-Name'].value.trim(),
    address:       form['pa-company-address'].value.trim(),
    city:          form['pa-city'].value.trim(),
    province:      form['pa-province'].value.trim(),
    zip:           form['pa-zip'].value.trim(),
    country:       form['pa-country'].value,
    lang:           shopifyLocale || 'en'
  };

  const isFr = shopifyLocale === 'fr';

if (!paCheckEmails()) {
  Swal.fire({
    icon: "warning",
    title: isFr
      ? "Les adresses courriel ne correspondent pas."
      : "Email addresses do not match."
  });
  paformsubmitBtn.textContent = isFr ? "Soumettre" : "Submit";
  return;
} else {
  try {
    const res = await fetch(form.action, {
      method: form.method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error(await res.text());

    paformsubmitBtn.textContent = isFr ? "Soumis" : "Submitted";

    Swal.fire({
      icon: "success",
      title: isFr
        ? "Votre demande a été soumise avec succès !"
        : "Your application has been submitted successfully!",
      text: isFr
        ? "Un courriel de confirmation vous a été envoyé. Nous vous contacterons dans un délai de deux jours ouvrables."
        : "A confirmation email has been sent to you, and we will contact you within two business days."
    });

    form.reset();
  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: "error",
      title: isFr
        ? "Échec de la soumission"
        : "Submission failed",
      text: isFr
        ? "Veuillez réessayer."
        : "Please try again."
    });
  }
}

  // if (!paCheckEmails()) {
  //   Swal.fire({
  //     icon: "warning",
  //     title: "Email addresses do not match."
  //   });
  //   paformsubmitBtn.textContent = "Submit";
  //   return;
  // } else {
  //   try {
  //     const res = await fetch(form.action, {
  //       method: form.method,
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(payload)
  //     });

  //     if (!res.ok) throw new Error(await res.text());
  //     paformsubmitBtn.textContent = "Submitted";
  //     Swal.fire({
  //       title: "Your application has been submitted successfully!",
  //       text: "A confirmation email has been sent to you, and we will contact you within two business days.",
  //       icon: "success"
  //     });
  //     form.reset();
  //   } catch (err) {
  //     console.error(err);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Submission failed",
  //       text: "Please try again."
  //     });
  //   }
  // }
});

function paCheckEmails() {
  var email = document.getElementById("pa-email").value.toLowerCase();
  var confirmEmail = document
    .getElementById("pa-confirm-email")
    .value.toLowerCase();

  if (email !== confirmEmail) {
    return false;
  }
  return true;
}

  } catch(e) { console.error(e); }
})();
})();
